import { render, staticRenderFns } from "./UserTabOverview.vue?vue&type=template&id=09e0ac5c&scoped=true&"
import script from "./UserTabOverview.vue?vue&type=script&lang=js&"
export * from "./UserTabOverview.vue?vue&type=script&lang=js&"
import style0 from "./UserTabOverview.vue?vue&type=style&index=0&id=09e0ac5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e0ac5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VDivider,VList,VListItem})
